import Image from 'next/image';

import lesson1Image from './images/lesson_course/1.png';
import lesson2Image from './images/lesson_course/2.png';
import lesson3Image from './images/lesson_course/3.png';

type Lesson = {
  title: string;
  image: StaticImageData;
  points: string[];
};

type LessonPointProps = {
  point: string;
};

type LessonProps = {
  lesson: Lesson;
};

const LessonPoint: React.FC<LessonPointProps> = ({ point }) => {
  return (
    <div className="flex items-center gap-x-2">
      <div className="box-border h-fit w-fit rounded bg-[#202956] px-[7px] py-[4px] text-[10px] font-bold text-white">
        &#10003;
      </div>
      <div className="text-[13px] font-bold">{point}</div>
    </div>
  );
};

const Lesson: React.FC<LessonProps> = ({ lesson }) => {
  return (
    <div className="z-20 flex flex-col items-center gap-y-4">
      <div className="text-xl font-bold text-gray-700">{lesson.title}</div>
      <div className="w-[115px]">
        <Image src={lesson.image} className="block w-full" alt="" />
      </div>
      <div className="flex flex-col gap-y-3">
        {lesson.points.map(point => (
          <LessonPoint key={point} point={point} />
        ))}
      </div>
    </div>
  );
};

const Component: React.FC = () => {
  const lessons: Lesson[] = [
    {
      title: 'Lesson 1',
      image: lesson1Image,
      points: [
        '独自開発SS打法についての説明',
        'SS打法のポイント',
        'トッププレーヤーが「強い」ワケ',
      ],
    },
    {
      title: 'Lesson 2',
      image: lesson2Image,
      points: [
        'SS打法で意識すべきスイングのコツ',
        'ループ系・スピード系の打ち分け方',
        '打球後の動き',
      ],
    },
    {
      title: 'Lesson 3',
      image: lesson3Image,
      points: [
        '安定したバックハンドを打つためには',
        '違和感があった場合の打開策',
      ],
    },
  ];
  return (
    <div className="hidden w-full md:block">
      <div className="my-3 text-right">
        「平岡義博考案：SS打法の身につけ方」の場合
      </div>
      <div className="relative flex justify-between bg-[#F5F6FF] px-5 pb-8 pt-12">
        {lessons.map(lesson => (
          <Lesson key={lesson.title} lesson={lesson} />
        ))}
        <div className="absolute left-[100px] top-[150px] z-10 h-[3px] w-[calc(100%-200px)] bg-[#202956]" />
      </div>
      <div className="mt-5 text-center text-lg font-bold">
        それぞれの動画コンテンツで、
        <br />
        技術の説明から習得のコツ、 対人戦での活用法について 丁寧に紹介します。
      </div>
    </div>
  );
};

export default Component;
